module.exports = __webpack_public_path__ + "static/img/ionicons.621bd38.svg";


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/styles/common/iconfont/fonts/ionicons.svg?v=2.0.0
// module id = 765
// module chunks = 34